import React from "react"

import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import { isEqual } from "lodash";

import {hasProperty, formatDate, truncate} from '../utils/utils';
import {cloneObject, getParam} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import ViewDesign from "../components/ViewDesign";
import ViewDesignItem from "../components/ViewDesignItem";
import Buffering from "../components/Buffering";

import { getDesignVersion } from "../utils/utilsDesign";


class ViewDesignVersion extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };

        this.handleNavClick = this.handleNavClick.bind(this);
        this.handleExport = this.handleExport.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

    }

    componentDidMount(){
        this.setup();
    }

    componentDidUpdate(prevProps, prevState){
        if (!isEqual(this.props.params, prevProps.params)){
            this.setup();
        }

        let StateChange = {};

        if (!isEqual(this.state, prevState)){
            if (this.state.loadData){
                this.loadData(this.state.idDesign, this.state.idVersion);
                StateChange.loadData = false;
            }

            this.setState(StateChange);
        }
    }

    setup(){
        let StateChange = {
            idVersion: null,
            idDesign: null,
            Design: null,
            isLoaded: false,
            isFailed: false, 
            loadData: false,
        }

        StateChange.idVersion = getParam('idVersion', this.props);
        if (StateChange.idVersion){
            StateChange.loadData = true;
        }

        StateChange.idDesign = getParam('idDesign', this.props);
        if (StateChange.idDesign){
            StateChange.loadData = true;
        }

        StateChange.isExporting = false;
        this.setState(StateChange);
    }

    loadData(id, idVersion){
        const onLoad = function(data){
            let StateChange = {};
            StateChange.Design = data;
            StateChange.isLoaded = true;
            this.setState(StateChange);
            return;
        }.bind(this);

        var onFail = function(e){
            let StateChange = {};
            StateChange.Design = null;
            StateChange.isFailed = true;

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        if (id){
            getDesignVersion(this.dsd, id, idVersion, onLoad, onFail);
        }

        return;
    }

    handleNavClick(event) {
        let idNode = null;

        if ("hash" in event.target){
            idNode = event.target.hash.substring(1);
        }
        else if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }

        if (idNode){
            const id = `${idNode}`
            const element = document.getElementById(id);
            if (element) {
              element.scrollIntoView({
                block: "start",
                behavior: "smooth",
              });
            }
        }

        event.preventDefault();
    };

    async handleExport(event){
        this.setState({isExporting: true});
        try {
            let Design = cloneObject(this.state.Design); 
            let Version = Design.Version;
            let idDesign = this.state.idDesign;
            let idVersion = this.state.idVersion;

            // Create JSON export
            const jsonString = JSON.stringify(Design, null, 2);
            const blob = new Blob([jsonString], { type: 'application/json' });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `design_${idDesign}_version_${idVersion}.json`;
            link.click();
        } finally {
            this.setState({isExporting: false});
        }
    }

    render() {
        if (this.state.isFailed){
            return <PD.ErrorBox>{this.state.errorMessage}</PD.ErrorBox>
        }

        if (this.state.isLoaded){
            return(
                <div>
                    <PD.Heading>{`Design: ${this.state.Design.name}`}</PD.Heading>
                    {this.state.Design.Version &&
                        <>
                           {this.viewVersion(this.state.Design.Version)}
                        </>
                    }
                    {this.viewDesign(this.state.Design)}
                </div>
            )
        }
        return null;
    };    

    viewVersion(Version){
        if (Version){
            return(
                <fieldset>
                    <legend>Named Version</legend>
                    <PD.Table className="panel">
                        <PD.Tbody>                                
                            {hasProperty(Version,'name') &&
                                <PD.Tr>                                
                                    <PD.Th>Name</PD.Th><PD.Td>{Version.name}</PD.Td>
                                </PD.Tr>
                            }

                            {hasProperty(Version,'description') &&
                                <PD.Tr>
                                    <PD.Th>Description</PD.Th>
                                    <PD.Td>
                                        <PD.MdPresent>
                                            {Version.description}
                                        </PD.MdPresent>                                    
                                    </PD.Td>
                                </PD.Tr>
                            }

                            {hasProperty(Version,'createdAt') &&
                                <PD.Tr>
                                    <PD.Th>Date/Time</PD.Th><PD.Td>{formatDate(Version.createdAt,'dmy hms')}</PD.Td>
                                </PD.Tr>
                            }
                        </PD.Tbody>
                    </PD.Table>
                    <PD.Button onClick={this.handleExport} name="btnExport" value={this.state.isExporting ? "" : "export"}>
                        {this.state.isExporting && <Buffering/>}
                    </PD.Button>
                </fieldset>
            )
        };
        return null;
    };

    viewDesign(Design){
        if (Design){
            let countDesignItems = 0;
            if (Design.DesignItems){
                if (Design.DesignItems.length){
                    countDesignItems = Design.DesignItems.length;
                }
            }

            return(
                <div>
                    <ViewDesign Design={Design} noLinks/>

                    <PD.Heading level="2">Index</PD.Heading>
                    {countDesignItems > 0 &&
                        <fieldset>
                            <legend>Design Items</legend>
                            <PD.Table className="list">
                                <PD.Thead>
                                    <PD.Tr>
                                        <PD.Th>Name</PD.Th>
                                        <PD.Th>Reference</PD.Th>
                                    </PD.Tr>
                                </PD.Thead>
                                <PD.Tbody>
                                    {
                                        Design.DesignItems.map(
                                            (DesignItem, pos) => 
                                            {
                                                switch (DesignItem.status){
                                                    case 'deprecated': return null;
                                                    default:
                                                        return (
                                                            <PD.Tr key={pos}>
                                                                <PD.Td>
                                                                    <PD.PdNavLink to={`#designitem_${DesignItem._id}`} onClick={this.handleNavClick}>{DesignItem.name}</PD.PdNavLink>
                                                                </PD.Td>
                                                                <PD.Td>
                                                                    {DesignItem.reference}
                                                                </PD.Td>
                                                            </PD.Tr>
                                                        )
                                                }
                                            }
                                        )
                                    }
                                </PD.Tbody>
                            </PD.Table>
                        </fieldset>
                    }

                    {
                        countDesignItems > 0 &&
                            <div>
                                <PD.Heading level="2">Design Items</PD.Heading>
                                {
                                    Design.DesignItems.map(
                                        (DesignItem, pos) => 
                                        {
                                            switch (DesignItem.status){
                                                case 'deprecated': return null;
                                                default:
                                                    return (
                                                        <fieldset key={pos} id={`designitem_${DesignItem._id}`}>
                                                            <ViewDesignItem DesignItem={DesignItem} noLinks/>
                                                        </fieldset>
                                                    )
                                            }
                                        }
                                    )
                                }
                            </div>
                    }
                </div>
            )
        }
    }
};
        
export default function ViewDesignVersion_wrapper(props) {
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ViewDesignVersion {...props} navigation={navigation} location={location} params={params} />;
}
